module.exports = __webpack_public_path__ + "img/ico_archive.aabb70b7.svg";